import { render, staticRenderFns } from "./b-radio-select-checkbox2.vue?vue&type=template&id=0774aeda&scoped=true"
import script from "./b-radio-select-checkbox2.vue?vue&type=script&lang=js"
export * from "./b-radio-select-checkbox2.vue?vue&type=script&lang=js"
import style0 from "./b-radio-select-checkbox2.vue?vue&type=style&index=0&id=0774aeda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0774aeda",
  null
  
)

export default component.exports